// extracted by mini-css-extract-plugin
export var alignCenter = "_9o-d";
export var bannerShown = "_9o-6";
export var buttonContent = "_9o-0";
export var cardList = "_9o-1";
export var centerContent = "_9o-2";
export var chevron = "_9o-3";
export var closePanelButton = "_9o-k";
export var conversationContextContainer = "_9o-l";
export var conversationDetailContainer = "_9o-4";
export var detailWrapper = "_9o-7";
export var dropdownButton = "_9o-e";
export var dropdownTitle = "_9o-9";
export var fullHeight = "_9o-5";
export var hidden = "_9o-a";
export var icon = "_9o-b";
export var mergeSuggestionWrapper = "_9o-m";
export var panel = "_9o-i";
export var portalButtonsWrapper = "_9o-c";
export var right = "_9o-j";
export var tableSummaryContainer = "_9o-8";
export var tableSummaryHeader = "_9o-g";
export var threeDotsButton = "_9o-f";
export var wide = "_9o-h";